import React, { useEffect,useState,useRef } from 'react';
import { Button } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import * as RestService from '../../services/eisRest';





  const SpecificationTab = (props) => {

   

    const [t] = useTranslation();      
   // const [isOpen, setIsOpen] = useState(false);    
    const [selectedRecord, setSelectedRecord] = useState();   
    const [specificationId, setSpecificationId] = useState();  
 //   const [article, setArticle] = useState([]);
    const [specFields, setSpecFields] = useState([]);
    const myRefs= useRef([]);

    const hideModal = () => {
      props.parentCallback();
    };
    
    
    useEffect(() => {      
    //  setArticle(props.object);   
      setSelectedRecord(props.object.id);
      setSpecificationId(props.object.specificationId);

      RestService.callAnyApi('article/getArticleSpecificationTemplate?id='+props.object.specificationId, null)
      .then((data) => {
           //console.log(data);
           setSpecFields(data);
           loadArticleSpecification(props.object.id,props.object.specificationId);

      }).catch((error) => {
        console.log(error);
      });

    }, [props.object])

  
    const loadArticleSpecification = (articleId,specificationId) =>{
          RestService.callAnyApi('article/getArticleSpecification?articleId='+articleId+'&specificationId='+specificationId, null)
          .then((data) => {
            //  console.log(data);
              data.map(function(item,i){
                let size=myRefs.current.length;
                for(let i=0;i< myRefs.current.length;i++) {
                  if(myRefs.current[i].id===item.name){
                    myRefs.current[i].value=item.value;
                  }
                }
              });
             
             // setSpecFields(data);
          }).catch((error) => {
            console.log(error);
          });
          return;
    }
    

    const handleNumericChange =(k,value)=>{
     
     
     
      // console.log(value);
       switch(k){
           case "sellingPriceExcludeVat":
              // setSellingPriceExcludeVat(value);
              
           break;
           
       }
   }

    const numberFormat = (num) => {
      return  parseFloat(num.replace(",", "."));
    }


   
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

    const save = (url,valuesArrObj) => {
         
    
      

      RestService.callAnyApi(url, valuesArrObj)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                      //    setArticle(data.responseObject);
                          toast.success(t('general.message.saveSucceed'));     
                          setSelectedRecord(data.responseObject.id);
                          props.loadedObject(data.responseObject);                                         
                          //hideModal();
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                 
          })
          .catch((error) => {               
            showError(error,null);
          });
    };

  

    const formik = useFormik({
      enableReinitialize: true,      
      initialValues: {    
       // name: article.name || "",
     
      },
      validationSchema: Yup.object({
      //   name: Yup.string()     
        //  .required(t('general.message.required')),
       //  nbr: Yup.string()     
       //   .required(t('general.message.required'))
          
      }),
      onSubmit: (values) => {  
        let size=myRefs.current.length;
        let valuesArrObj = [];                
        for(let i=0;i< myRefs.current.length;i++) {
          //console.log(myRefs.current[i].id+" > "+myRefs.current[i].value);
          valuesArrObj.push({
             "parameter": myRefs.current[i].id,
             "value": myRefs.current[i].value
          });
        }
          save("article/saveArticleSpecification?articleId="+selectedRecord+"&specificationId="+specificationId,valuesArrObj);         
      }
    });

    return (
      <>    
         <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>     
                    <form onSubmit={formik.handleSubmit}>                                            

                        <div className="row">

                                  {specFields.map(function(item,i){
                                      return (
                                            <>
                                                      {item.valueType==='string' ?
                                                                                                
                                                          <div className="col-6 col-sm-6 col-lg-6">
                                                            <div className="form-group">
                                                              <label>{t('specificationTemplate.label.'+item.variableName)} {item.unitMeasure ? "("+item.unitMeasure+")" : <></>}</label>
                                                              <input type="text" class="form-control" id={item.variableName} ref={(el) => (myRefs.current[i] = el)} placeholder={t('specificationTemplate.label.'+item.variableName)}  />
                                                            </div>                                                         
                                                          </div>         
                                                       :
                                                          <div className="col-6 col-sm-6 col-lg-6">
                                                              <div className="form-group">
                                                                <label>{t('specificationTemplate.label.'+item.variableName)} {item.unitMeasure ? "("+item.unitMeasure+")" : <></>}</label>
                                                                <input type="number" className="form-control" id={item.variableName}  ref={(el) => (myRefs.current[i] = el)} step="any"/>                                   
                                                              </div>
                                                          </div>
                                                       } 
                                                    
                                            </>
                                      )
                                      
                                })}

                         </div>

                         <div className="card-footer">
                            <Button className="btn-primary" type="submit">{t('general.button.save')}</Button>     
                            <Button className="btn-default float-right" onClick={hideModal}>{t('general.button.cancel')}</Button>                                                        	            	       			
                  			</div>

                  </form>

              </div>    


      </>
    );
  };

 export default SpecificationTab;